export const Icon = () => {
    return (
        <svg viewBox="0 0 50.2 50.2" fill="#D4BC87">
            <path
                d="M25.1,4.7c-11.3,0-20.4,9.1-20.4,20.4c0,1.3-1.1,2.4-2.4,2.4S0,26.4,0,25.1
					C0,11.2,11.2,0,25.1,0s25.1,11.2,25.1,25.1S39,50.2,25.1,50.2c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4c11.3,0,20.4-9.1,20.4-20.4
					C45.5,13.8,36.4,4.7,25.1,4.7z"
            />
        </svg>
    );
};
